import {Component, OnInit} from "@angular/core";
import {SESSION_STORAGE_KEYS} from "../common/session-storage-keys";
import {BreadcrumbService} from "xng-breadcrumb";
import {UnityConnectTransaction} from "../common/model/unity-connect-transaction";
import {Router} from "@angular/router";

@Component({
    selector: 'dp-matter-summary-home',
    templateUrl: './matter-summary-home.component.html'
})
export class MatterSummaryHomeComponent implements OnInit {

    constructor( ) {

    }

    ngOnInit() {
    }

}